import React from "react";
import cn from "./helpers/cn";
import Typography from "./Typography";
import IconButton from "./IconButton";

interface DialogTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  disableTypography?: boolean;
  /**
   * Extensão comum no projeto: quando fornecido, mostra um botão de fechar
   * no canto direito. Se omitido mas houver `onClose` no Dialog, NÃO mostra
   * automaticamente — siga o MUI v4 onde o usuário coloca o botão manualmente.
   */
  onClose?: () => void;
  children?: React.ReactNode;
}

const DialogTitle = React.forwardRef<HTMLDivElement, DialogTitleProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    disableTypography = false,
    onClose,
    children,
    ...other
  } = props;

  // Garante padding-right pra não sobrepor o botão de fechar.
  const hasClose = !!onClose;

  return (
    <Component
      ref={ref}
      className={cn(
        // MUI v4: padding 16px 24px, flex shrink 0
        "px-6 py-4 m-0 shrink-0",
        hasClose && "pr-12 relative",
        className
      )}
      {...other}
    >
      {disableTypography
        ? children
        : <Typography variant="h6" component="h2">{children}</Typography>}

      {hasClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          className="absolute top-2 right-2"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </IconButton>
      )}
    </Component>
  );
});

DialogTitle.displayName = "DialogTitle";

export default DialogTitle;
